import React from 'react';

const DocumentsSection = ({ title, subtitle, description, items = [] }) => {
    return (
        <div className="mxd-section padding-pre-grid my-4 my-md-5 py-3 py-md-4">
            <div className="mxd-container grid-container">
                <div className="mxd-block">
                    <div className="mxd-section-title">
                        <div className="container-fluid p-0">
                            <div className="row g-0">
                                <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                    <div className="mxd-section-title__hrtitle">
                                        <h2 className="reveal-type">{title}</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                    <div className="mxd-section-title__hrdescr">
                                        <p className="anim-uni-in-up">{subtitle}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container-fluid px-0">
                        <div className="row gx-4 gy-4">
                            <div className="col-12 col-xl-5">
                                <div className="bg-base-tint radius-m padding-4 h-100">
                                    <i className="ph-bold ph-files fs-1 text-tertiary mb-3 d-block"></i>
                                    <p className="t-large text-secondary mb-0">{description}</p>
                                </div>
                            </div>
                            <div className="col-12 col-xl-7">
                                <div className="bg-base-tint radius-m padding-4 h-100">
                                    <ul className="mxd-check-list">
                                        {items.map((item, index) => (
                                            <li key={index}>
                                                <i className="ph ph-check"></i>
                                                <span>{item}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentsSection;
